import { Box, Stack } from "@mui/material";
import HotelInvoiceItem from "./HotelInvoiceItem";

const PaidHotelInvoices = ({ paidHotelInvoices }) => {
    return (
        <Stack component="ul" spacing={2} sx={{ listStyle: 'none', p: 0, mb: 3 }}>
            {paidHotelInvoices.map((inv) => (
                <Box component="li" key={inv.id}>
                    <HotelInvoiceItem invoice={inv} />
                </Box>
            ))}
        </Stack>
    );
};

export default PaidHotelInvoices;
